import React, { FunctionComponent, useEffect, useState } from 'react';
import {
    Row as BSRow,
    DropdownButton,
    Dropdown,
} from 'react-bootstrap';
import { ApplicationState } from '../../../redux/States';
import { ErrorDispatches } from '../../../redux/Dispatches';
import { ConnectedProps, connect } from 'react-redux';
import {
    AuthedLayout,
    EditableTableDiv,
    HeaderDisplayKeysWithType,
} from '../../../components';
import { useClassGrade, useSemGrade } from '../../../hook';
import { FluorStudentStatistic, UserInfo } from '../../../model';
import apis from '../../../apis';
import { SightContext } from '../../TableHeaders/SightHeader';
import {
    downloadDataAsExcel,
    printDataAsTable,
    SheetHeaderDisplay,
} from '../../../utils';
import { toast } from 'react-toastify';
type PageData = FluorStudentStatistic & { joinrate: string } & { isFluorrate: string };

const tableHeader: (SheetHeaderDisplay<PageData> &
    HeaderDisplayKeysWithType<PageData>)[] = [
        {
            display: '年級', property: 'grade',
            onSheetRender: (value) =>
                value === 0 ? 0 : value ?? ''
        },
        {
            display: '學生數', property: 'studentCount',
            onSheetRender: (value) =>
                value === 0 ? 0 : value ?? 0
        },
        {
            display: '不參與數', property: 'neverFluor',
            onSheetRender: (value) =>
                value === 0 ? 0 : value ?? 0
        },
        {
            display: '參與率', property: 'joinrate',
            onSheetRender: (value) =>
                value === 0 ? 0 : value ?? ''
        },
        {
            display: '未實施人次', property: 'yearSemDontFluor',
            onSheetRender: (value) =>
                value === 0 ? 0 : value ?? 0
        },
        {
            display: '應實施人次', property: 'fluorStudentCount',
            onSheetRender: (value) =>
                value === 0 ? 0 : value ?? 0
        },
        {
            display: '實施人次', property: 'isFluorStudentCount',
            onSheetRender: (value) =>
                value === 0 ? 0 : value ?? 0
        },
        {
            display: '執行率', property: 'isFluorrate',
            onSheetRender: (value) =>
                value === 0 ? 0 : value ?? ''
        },
    ];

const mapState = (app: ApplicationState) => ({ ...app.auth });
const mapDispatch = ErrorDispatches;

const connector = connect(mapState, mapDispatch);
type Props = ConnectedProps<typeof connector>;

const teeFluorStaticGrade: FunctionComponent<Props> = ({
    user,
    catchErrorForModal,
}) => {
    const { currentSemester = '', semesters = {} } = user || {};
    const [currentSem, setCurrentSem] = useState(currentSemester);
    const { year = -1, sem = -1 } = semesters[currentSem];
    const [students, setStudents] = useState<PageData[]>([]);
    const [userinfo, setUser] = useState<UserInfo>();
    const { yearSem, element } = useSemGrade();

    useEffect(() => {
        if (yearSem) {
            apis.getUserInfo()
                .then((u) => {
                    setUser(u);
                })
                .catch(catchErrorForModal);

            toast
                .promise(
                    apis
                        .getFluorGradeStatic(yearSem?.year, yearSem?.sem)
                        .then((r) =>
                            setStudents(
                                r.map((s) => {
                                    const studentCount = Number(s.studentCount) || 0;

                                    // 不參與人數（只有 neverFluor）
                                    const never = Number(s.neverFluor) || 0;

                                    const week = Number(s.fluorWeek) || 0;

                                    // 未實施人次（後端已算好：LackCount 加總）
                                    const undone = Number(s.yearSemDontFluor) || 0;

                                    // 應實施人次 = (學生數 - 不參與數) * 週數
                                    const shouldDo = (studentCount - never) * week;

                                    // 實施人次 = 應實施人次 - 未實施人次
                                    const done = shouldDo - undone;

                                    return {
                                        ...s,

                                        neverFluor: never ?? 0,                 // 不參與數
                                        fluorStudentCount: shouldDo,       // 應實施人次
                                        isFluorStudentCount: done,         // 實施人次
                                        yearSemDontFluor: undone ?? 0,          // 未實施人次

                                        // 參與率 = (學生數 - 不參與數) / 學生數
                                        joinrate: percent(studentCount - never, studentCount),

                                        // 執行率 = 實施人次 / 應實施人次
                                        isFluorrate: percent(done, shouldDo),
                                    };
                                })
                            )
                        ),
                    {
                        pending: '資料載入中......',
                        success: '資料載入成功！',
                        error: '資料載入失敗！請查看錯誤資訊。',
                    }
                )
        }
    }, [yearSem?.year, yearSem?.sem]);

    console.log(students)
    return (
        <AuthedLayout>
            <BSRow className="justify-content-between">
                <span className="mr-3">{element}</span>
                <DropdownButton
                    id="tee-fluor-static-grade-export"
                    title="匯出"
                    variant="success"
                    disabled={!students.length}
                >
                    <Dropdown.Item
                        onClick={() => {
                            downloadDataAsExcel({
                                title:
                                    `${user.schools[user.currentSchool].name}` +
                                    `${yearSem?.year}學年` +
                                    `${yearSem?.sem}學期_含氟漱口水執行統計(年級)`,
                                values: students,
                                headers: tableHeader,
                                context: SightContext,
                                footer:
                                    '承辦人:　　　　　　　　　　　　　組長:　　　　　　　　　　　　　主任:　　　　　　　　　　　　　　校長:　　　　　　　　　　　　',
                                exportfile: userinfo?.exportFileType,
                            });
                        }}
                    >
                        Excel 下載
                    </Dropdown.Item>

                    <Dropdown.Item
                        onClick={() => {
                            printDataAsTable({
                                title:
                                    `${user.schools[user.currentSchool].name}` +
                                    `${yearSem?.year}學年` +
                                    `${yearSem?.sem}學期_含氟漱口水執行統計(年級)`,
                                values: students,
                                headers: tableHeader,
                                context: SightContext,
                                footer:
                                    '承辦人:　　　　　　　　　　　　　組長:　　　　　　　　　　　　　主任:　　　　　　　　　　　　　　校長:　　　　　　　　　　　　',
                            });
                        }}
                    >
                        列印
                    </Dropdown.Item>
                </DropdownButton>
            </BSRow>
            <hr />
            <BSRow>
                <EditableTableDiv
                    headers={tableHeader}
                    values={students}
                    context={SightContext}
                />
            </BSRow>
        </AuthedLayout>
    );
};

function percent(value: number, denominator: number): string {
    if (!denominator) return '0.00%';
    return (((value / denominator)) * 100).toFixed(2) + '%';
}

export const TeeFluorStaticGrade = connector(teeFluorStaticGrade);
